var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NotificationsTwitterConfiguration'),_c('div',{staticClass:"m-2"}),_c('NotificationsTwitterMessage',{attrs:{"twitterConfigCompleted":_vm.twitterConfigCompleted}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }